import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { useIntl } from 'react-intl';
import TableCell from './table-head-cell';
import { TOPICS_CELL_WIDTH_REPARTITION } from '../../utils/constants';

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(3),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        display:"flex",
    }
}));

const Head = () => {
    const classes = useStyles();
    const { formatMessage } = useIntl();

    return (
        <Grid container className={classes.root}>
            <TableCell
                width={TOPICS_CELL_WIDTH_REPARTITION[0] + '%'} 
                text={formatMessage({id:"app.topics", defaultMessage:"Topics"}) }
            />
            <TableCell
                width={TOPICS_CELL_WIDTH_REPARTITION[1] + '%'}
                text="Conversations"
                sort active
            />
            <TableCell
                width={TOPICS_CELL_WIDTH_REPARTITION[2] + '%'} 
                text={ formatMessage({id:"app.feeling", defaultMessage:"Feeling"}) }
            />
            <TableCell
                width={TOPICS_CELL_WIDTH_REPARTITION[3] + '%'} 
                text={ formatMessage({id:"app.duration", defaultMessage:"Duration"}) }
            />
            <TableCell
                width={TOPICS_CELL_WIDTH_REPARTITION[4] + '%'} 
                text={ formatMessage({id:"app.touchpoint", defaultMessage:"Touchpoint"}) }
            />
            <TableCell
                width={TOPICS_CELL_WIDTH_REPARTITION[5] + '%'}
                text={formatMessage({id:"app.other.topics", defaultMessage:"Other topics"})}
            />
        </Grid>
    )
}

export default Head;
